import { render, staticRenderFns } from "./my-process-designer-header.vue?vue&type=template&id=63edea7e"
import script from "./my-process-designer-header.vue?vue&type=script&lang=js"
export * from "./my-process-designer-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports